import axios from "axios";
import { SendToast } from "@networkraildigitalfactory/components";
import { logout } from "./session";

const createRequest = (baseURL) => {
  const instance = axios.create({ baseURL, withCredentials: true });
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 403) {
        logout();
        window.location.href = "/";
        SendToast("Your session has expired. Please log in.", "error");
      }
      return Promise.reject(error);
    }
  );
  instance.interceptors.request.use(
    (config) => {
      config.withCredentials = true;
      return config;
    },
    (error) => {
      if (error.response && error.response.status === 403) {
        logout();
        window.location.href = "/";
        SendToast("Your session has expired. Please log in.", "error");
      }
      return Promise.reject(error);
    }
  );
  return instance;
};

export default createRequest;
